import { useContext, useEffect, useState } from 'react'
import { authContext } from 'contexts/AuthContext'
import allClaimApprovalTabs from '../data/allClaimApprovalTabs'

const useApprovalFilterTabs = () => {
  const { auth } = useContext(authContext)
  const [permission, setPermission] = useState(null)
  const [filteredTabs, setFilteredTabs] = useState()

  useEffect(() => {
    setPermission(auth?.data?.staff?.permissions?.map(({ id }) => id))
  }, [auth])

  useEffect(() => {
    setFilteredTabs(
      allClaimApprovalTabs
        .map((item) => {
          if (permission?.includes(item?.permissionId)) {
            return item
          }
          return undefined
        })
        .filter((item) => item !== undefined)
    )
  }, [permission])

  return { filteredTabs }
}

export default useApprovalFilterTabs
